import {useCallback, useEffect, useMemo, useRef} from 'react'

export function useIssueDeletionCompletion({
  owner,
  repo,
  number,
  refresh,
  closePane,
}: {
  owner: string
  repo: string
  number: number
  refresh?: () => Promise<void>
  closePane: (opts: {force: boolean}) => Promise<boolean>
}) {
  const scope = useMemo(() => ({owner, repo, number}), [owner, repo, number])
  const activeScopeRef = useRef<typeof scope | null>(null)
  useEffect(() => {
    activeScopeRef.current = scope
    return () => {
      activeScopeRef.current = null
    }
  }, [scope])

  const onIssueDelete = useCallback(async () => {
    await refresh?.()
  }, [refresh])

  // The dialog owns navigation after completion. Never close again from the refresh callback,
  // or let a callback retained by an old mutation close a newly opened issue.
  const navigateAfterIssueDeletion = useCallback(() => {
    if (activeScopeRef.current !== scope) return
    activeScopeRef.current = null
    void closePane({force: true})
  }, [closePane, scope])

  return {onIssueDelete, navigateAfterIssueDeletion}
}
